import { render, staticRenderFns } from "./TransitionFade.vue?vue&type=template&id=1ccf2c1b&"
var script = {}
import style0 from "./TransitionFade.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports